import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import React, { useState } from 'react';
import { RequestExperiment } from '../../api/types';

interface RequestAccessFormExperimentsProps {
    experiments: RequestExperiment[];
    onChange: (value: string) => void;
    translations: Record<string, string>;
}

export const RequestAccessFormExperiments: React.FC<RequestAccessFormExperimentsProps> = ({
    experiments,
    onChange,
    translations,
}) => {
    const [selectedExperiment, setSelectedExperiment] = useState('');

    const handleExperimentChange = (event: SelectChangeEvent<string>) => {
        setSelectedExperiment(event.target.value);
        onChange(event.target.value);
    };

    return (
        <Box my={2}>
            <FormControl fullWidth>
                <InputLabel id="experiment">{translations.ACRQ_EXPERIMENT_LABEL}</InputLabel>
                <Select
                    fullWidth
                    labelId="experiment"
                    id="experiment"
                    label={translations.ACRQ_EXPERIMENT_LABEL}
                    value={selectedExperiment}
                    onChange={handleExperimentChange}
                >
                    {experiments.map(({ requestExperiment }) => (
                        <MenuItem value={requestExperiment} key={requestExperiment}>
                            {requestExperiment}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};
